import React from 'react';
import { l } from 'app/blocks/common/codes';
import { getQueryParamSafe } from 'app/blocks/common/utils';
import { authenticateASLogin, getConnectRedirectUrl } from 'app/blocks/middleware/authentication';

import 'app/styles/uitextloader.scss';
import { navigateToDashboard } from 'app/blocks/middleware/dashboard';

export function isFinalizeLoginPage() {
    const queryParams = getQueryParamSafe(window.location.href);
    return !!queryParams?.code && ((!queryParams?.message && !queryParams?.status) || queryParams?.action === 'login');
}

const shouldNavigateToDashboard = pathname => {
    const path = pathname.replace('/', '').replace('#', '');
    return (
        !path.startsWith('index.html') || path.startsWith('index.html/login') || path.startsWith('index.html/recover')
    );
};

async function getRedirectUrl() {
    const baseUrl = await getConnectRedirectUrl();
    const url = new URL(window.location.pathname + window.location.search + window.location.hash, baseUrl);

    const toRemove = [];
    url.searchParams.forEach((value, key) => {
        if (key !== 'action' && key !== 'invitationToken' && key !== 'campaign') {
            toRemove.push({ key, value });
        }
    });

    toRemove.forEach(e => {
        url.searchParams.delete(e.key, e.value);
    });

    return url.href;
}

export default class FinalizeLoginPage extends React.Component {
    async componentDidMount() {
        const redirectUrl = await getRedirectUrl();
        const ranStr = localStorage.getItem('STATE_ID');
        const queryParams = getQueryParamSafe(window.location.href);
        queryParams.redirectUrl = redirectUrl;

        if (queryParams?.code && queryParams?.redirectUrl) {
            if (true || ranStr === queryParams?.state) {
                this.authenticateUser(queryParams);
            } else {
                setTimeout(() => {
                    window.location.replace('/index.html/errorRedirectHome');
                }, 2000);
            }
        }
    }

    timeoutPromise = () =>
        new Promise((resolve, reject) => {
            setTimeout(() => {
                reject(new Error('Timeout occurred'));
            }, parseInt(l('BUTTONS.AUTH_TIMEOUT'), 10));
        });

    authenticateUser = async queryParams => {
        try {
            await Promise.race([authenticateASLogin(queryParams), this.timeoutPromise()]);
            setTimeout(() => {
                if (shouldNavigateToDashboard(window.location.pathname)) {
                    navigateToDashboard();
                } else if (window.location.search) {
                    window.history.replaceState(
                        {},
                        document.title,
                        window.location.pathname
                            ? `${window.location.origin}${window.location.pathname}`
                            : window.location.origin,
                    );
                }
                window.location.reload();
            }, 2000);
        } catch (err) {
            setTimeout(() => {
                window.location.replace('/index.html/errorRedirectHome');
            }, 2000);
        }
    };

    render() {
        return (
            <div className="Loading-screen">
                <div className="loader" />
                <div style={{ fontSize: '20px', lineHeight: '30px', padding: '20px', textAlign: 'center' }}>
                    Please wait while Wiley Authors loads your page
                </div>
            </div>
        );
    }
}
